import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateRequestState from './request';
import updateWorkflowsState from './workflows';
import updateWorkspacesState from './workspace';

const handlers = {
  ...updateRequestState,
  ...updateWorkflowsState,
  ...updateWorkspacesState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
